export interface ISessionMeetingAction {
  readonly delete: boolean
  readonly edit: boolean
  readonly add: boolean
  readonly new: boolean
}
